import React, { Component } from "react";
import tableIcons from "./MaterialTableIcons";
import Button from "../Button";
import { DocumentMinusIcon } from "@heroicons/react/24/outline";
import {
  TablePagination,
  TablePaginationTypeMap,
  TablePaginationBaseProps,
} from "@material-ui/core";
import CustomLoader from "../CustomLoader";
import MaterialTable, {
  MaterialTableProps,
  MTableToolbar,
} from "material-table";

const defaultHeaderStyle = {
  color: "#203A75",
  fontWeight: "bold",
  fontSize: "12px",
  whiteSpace: "nowrap",
  center: true,
} as React.CSSProperties;

const defaultRowStyle = {
  whiteSpace: "nowrap",
  fontSize: "12px",
} as React.CSSProperties;

interface ITablePagination
  extends TablePaginationTypeMap<TablePaginationBaseProps, React.ElementType> {
  ActionsComponent?: any[];
  onChangePage?: any[];
  onChangeRowsPerPage?: any;
}
const PatchedPagination: React.FC<ITablePagination> = ({
  ActionsComponent,
  onChangePage,
  onChangeRowsPerPage,
  ...tablePaginationProps
}) => {
  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      SelectProps={{
        IconComponent: () => <div></div>,
      }}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;
        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
};

interface IMaterialInvoiceTable extends MaterialTableProps<object> {
  showTitle?: boolean;
  showHeader?: boolean;
  headerStyle?: React.CSSProperties;
  rowStyle?: React.CSSProperties;
  showToolbar?: boolean;
  toolbarSearch?: boolean;
  searchFieldAlignment?: "left" | "right";
  tableRef?: any;
  paging?: boolean;
  pageSize?: number;
  selectedRows?: any;
  selection?: boolean;
  setConfirmModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onSelectionChange?: ((data: any[], rowData?: any) => void) | undefined;
  grouping?: boolean;
  groupedBy?: React.ReactNode;
  exportButton?: boolean;
  toolBarComponent?: any;
  detailpanel?: any;
}
const MaterialInvoiceTable: React.FC<IMaterialInvoiceTable> = ({
  data,
  isLoading,
  columns,
  showTitle = false,
  toolbarSearch,
  showHeader = true,
  headerStyle = defaultHeaderStyle,
  rowStyle = defaultRowStyle,
  showToolbar = false,
  searchFieldAlignment = "left",
  tableRef,
  paging = true,
  pageSize = 10,
  selection,
  selectedRows = [],
  setConfirmModalOpen,
  onSelectionChange,
  grouping,
  groupedBy,
  exportButton,
  toolBarComponent,
  detailpanel,
  ...props
}) => {
  return (
    <>
      <MaterialTable
        data={data}
        isLoading={isLoading}
        columns={columns}
        onSelectionChange={(rows) => {
          onSelectionChange && onSelectionChange(rows);
        }}
        options={{
          header: showHeader,
          exportButton: exportButton
            ? { csv: exportButton, pdf: false }
            : false,
          selection: selection,
          search: toolbarSearch,
          showTitle: showTitle,
          searchFieldAlignment: searchFieldAlignment,
          headerStyle: headerStyle,
          toolbar: showToolbar,
          rowStyle: rowStyle,
          padding: "dense",
          paging: paging,
          pageSize: pageSize,
          pageSizeOptions: [10, 20, 30, 40, 50],
          showTextRowsSelected: false,

          selectionProps: (rowData) => {
            const checked = rowData.tableData.checked
              ? (rowData.agreementIsActive === true &&
                  rowData.isActive === true) ||
                rowData.isActive === true ||
                rowData.isActive === "true" ||
                rowData.isActive === "Active" ||
                rowData.isInActive === false ||
                (!rowData.agreementIsActive && rowData.isActive === true)
                ? { checked: true }
                : { checked: false }
              : {};
            return {
              disabled:
                rowData.isActive === false ||
                rowData.isActive === "Inactive" ||
                rowData.isInActive === true ||
                rowData.status === "Terminated" ||
                rowData.isActive === "false" ||
                rowData.status === "Inactive" ||
                rowData.agreementIsActive === false,
              ...checked,
            };
          },
          actionsColumnIndex: -1,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: isLoading ? (
              <CustomLoader />
            ) : (
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                No records to display.
              </label>
            ),
          },
        }}
        components={{
          Pagination: PatchedPagination,
          OverlayLoading: () => <></>,
        }}
        style={{ overflowX: "auto" }}
        icons={tableIcons}
        tableRef={tableRef}
        detailPanel={detailpanel}
        {...props}
      />
    </>
  );
};

export default MaterialInvoiceTable;
